import { render, staticRenderFns } from "./JobShadowView.vue?vue&type=template&id=140b24c0&scoped=true&"
import script from "./JobShadowView.vue?vue&type=script&lang=js&"
export * from "./JobShadowView.vue?vue&type=script&lang=js&"
import style0 from "./JobShadowView.vue?vue&type=style&index=0&id=140b24c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140b24c0",
  null
  
)

export default component.exports